import React, { useContext, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import AdminRoutes from "./AdminRoutes";
import UserRoutes from "./UserRoutes";
import PublicRoutes from "./PublicRoutes";
import CompanyRoutes from "./CompanyRoutes";
import AppLayout from "../Components/AppLayout";
import { UserContext } from "../App";
import UserLayout from "../Components/UserLayout";
import { DateFilterProvider } from "../Contexts/DateFilterContext";
import ApiKeyNotifier from "../Utils/Notification/ApiKeyNotifier";
import { SwitchProvider } from "../Contexts/SwitchContext";

const AppRoutes = () => {
  const { userData } = useContext(UserContext);

  const [flag, setFlag] = useState(false);

  let routesComponent;

  if (userData?.verified) {
    switch (userData?.role) {
      case "admin":
        routesComponent = (
          <AppLayout userType={"admin"} contents={<AdminRoutes />} />
        );
        break;
      case "user":
        routesComponent = (
          <AppLayout
            setFlag={setFlag}
            userType={"user"}
            contents={
              <DateFilterProvider>
                <SwitchProvider>
                  <UserLayout name={userData?.name}>
                    <UserRoutes />
                  </UserLayout>
                </SwitchProvider>
              </DateFilterProvider>
            }
          />
        );
        break;
      case "company":
        routesComponent = flag ? (
          <AppLayout
            setFlag={setFlag}
            userType="user"
            contents={
              <DateFilterProvider>
                <SwitchProvider>
                  <UserLayout name={userData?.name}>
                    <UserRoutes />
                  </UserLayout>
                </SwitchProvider>
              </DateFilterProvider>
            }
          />
        ) : (
          <AppLayout
            setFlag={setFlag}
            userType="company"
            contents={<CompanyRoutes setFlag={setFlag} />}
          />
        );

        break;
      default:
        routesComponent = <PublicRoutes />;
        break;
    }
  } else {
    routesComponent = <PublicRoutes />;
  }

  return (
    <BrowserRouter>
      <ApiKeyNotifier />
      {routesComponent}
    </BrowserRouter>
  );
};

export default AppRoutes;
